import { Divider, Paper } from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { FC, useEffect, useState } from "react";
import { FaFileAlt } from "react-icons/fa";
import { FINANCIMENTO_INDIRETO } from "src/constants";
import { StringUtil } from "src/framework/commons/StringUtil";
import { useObservable } from "src/framework/store/storeUtil";
import { formasPagamentoTextoInformativo$ } from "src/store/global.store";
import { CartaCreditoType, PedidoPagamento, PedidoType, TiposPagamentoIDType } from "src/types";
import { FinanciamentoIndireto } from "../../financiamentoIndireto/FinanciamentoIndireto";
import { HeaderFormaPagamento } from "../HeaderFormaPagamento";
import "./styles.scss"

interface FinanciamentoIndiretoSoloProperties {
    pedido: PedidoType | null;
    onConfirmar: (pagamento: PedidoPagamento, tipoPagamento: TiposPagamentoIDType) => void;
}

const FinanciamentoIndiretoSolo: FC<FinanciamentoIndiretoSoloProperties> = ({
    pedido,
    onConfirmar,
}) => {
    const [disabled, setDisabled] = useState<boolean>(false);
    const textoInformativo = useObservable(formasPagamentoTextoInformativo$);
    const [texto, setTexto] = useState("");

    useEffect(() => {
        if (textoInformativo) {
            setTexto(StringUtil.retornaTextoInformativo(textoInformativo.data, FINANCIMENTO_INDIRETO.id));
        }
    }, [textoInformativo])

    return <div className="FinanciamentoIndiretoSolo">

        <HeaderFormaPagamento
            icon={<><FaFileAlt /></>}
            title={<>Financiamento externo</>}
        />

        {texto ? <>
            <div className="row">
                <div className="X12">
                    <Alert severity="warning" className="texto-alerta">
                        {texto}
                    </Alert>
                </div>
            </div>
        </> : null}

        <FinanciamentoIndireto
            checkout={true}
            formaPagamentoId={FINANCIMENTO_INDIRETO.id}
            codigoVenda={pedido?.codigo_venda || ""}
            cupomDesconto={pedido?.codigo_cupom || ""}
            valorPedido={pedido?.valor_pendente}
            pagamentoId={pedido?.pagamento_id || 0}
            solo
            exibirBotoes={true}
            onConfirmar={(value: CartaCreditoType) => {
                if (pedido) {
                    const cartaCredito: CartaCreditoType = {
                        valor: pedido.valor_pendente,
                        valor_original: pedido.valor_pendente,
                        banco: value.banco,
                        carta: value.carta,
                    }

                    const pedidoPagamento: PedidoPagamento = {
                        forma_pagamento: FINANCIMENTO_INDIRETO.id,
                        pedido: pedido?.id,
                        itens: {
                            cartas_credito: [cartaCredito]
                        }
                    }

                    onConfirmar(pedidoPagamento, FINANCIMENTO_INDIRETO.id as any)
                }
            }} />
    </div>
}

export { FinanciamentoIndiretoSolo }